import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const DynamicOffcanvas = ({
  // visible: isVisible, // renamed to avoid ESLint warning
  // onClose,
  title,
  schema = [],
  section,
  formData = {},
  onSubmit,
  mode = 'edit',
}) => {
  const [formState, setFormState] = useState({});
const [shouldReset, setShouldReset] = useState(false);

  useEffect(() => {
    const initialState = {};
    schema.forEach(field => {
      initialState[field.name] =
        formData[field.name] ??
        field.default ??
        (field.type === 'checkbox' ? false : '');
    });
    setFormState(initialState);

  setShouldReset(mode === 'add');
}, [formData, schema, mode]);

  const handleChange = (e, name, type) => {
    const value = type === 'checkbox' ? e.target.checked : e.target.value;
    setFormState(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(section, formState); // Pass to parent
    // onClose();
  };

  // if (!isVisible) return null; // Correct use of isVisible
useEffect(() => {
  const offcanvasEl = document.getElementById('MastersDynamicOffcanvas');

  const handleOffcanvasHidden = () => {
    if (shouldReset) {
      const resetState = {};
      schema.forEach(field => {
        resetState[field.name] =
          field.default ?? (field.type === 'checkbox' ? false : '');
      });
      setFormState(resetState);
    }
  };

  offcanvasEl?.addEventListener('hidden.bs.offcanvas', handleOffcanvasHidden);

  return () => {
    offcanvasEl?.removeEventListener('hidden.bs.offcanvas', handleOffcanvasHidden);
  };
}, [schema, shouldReset]);

  return (
<div>
   <style>
        {`
        @media (max-width: 576px) {
          #MastersDynamicOffcanvas {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #MastersDynamicOffcanvas {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #MastersDynamicOffcanvas {
            width: 25% !important;
          }
        }
          
        @media (min-width: 1441px)  {
          #MastersDynamicOffcanvas {
            width: 16% !important;
          }
        }
        `}
      </style>
    <div
      className="offcanvas offcanvas-end "
      id="MastersDynamicOffcanvas"
       aria-labelledby="MastersDynamicOffcanvas"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          {mode === 'edit' ? `Edit ${title}` : `Add ${title}`}
        </h5>
        <div className='d-flex align-items-center ms-auto'>
         <button
              type="submit"
              className="btn btn-sm btn-outline-success me-2"
              title= {mode === 'edit' ? 'Update' : 'Submit'}
            >
              <i className="fa fa-check fs-4"></i>
            </button>
        <button type="button" className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
            aria-label="Close"
         ></button></div>
      </div>
      <div className="offcanvas-body">
        <form onSubmit={handleSubmit}>
          {schema.map(field => {
            if (field.type === 'hidden') {
              return (
                <input
                  key={field.name}
                  type="hidden"
                  name={field.name}
                  value={formState[field.name]}
                />
              );
            }

            return (
              <div className="mb-3 " key={field.name}>
                {field.type !== 'checkbox' && (
                  <label className="form-label">{field.label}</label>
                )}
                {field.type === 'text' || field.type === 'number' ? (
                  <input
                    type={field.type}
                    className="form-control"
                    name={field.name}
                    value={formState[field.name]}
                    required={field.required}
                    onChange={(e) =>
                      handleChange(e, field.name, field.type)
                    }
                  />
                ) : field.type === 'textarea' ? (
                  <textarea
                    className="form-control"
                    name={field.name}
                    rows="3"
                    value={formState[field.name]}
                    onChange={(e) =>
                      handleChange(e, field.name, field.type)
                    }
                  ></textarea>
                ) : field.type === 'checkbox' ? (
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={field.name}
                      checked={formState[field.name]}
                      onChange={(e) =>
                        handleChange(e, field.name, 'checkbox')
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor={field.name}
                    >
                      {field.label}
                    </label>
                  </div>
                ) : null}
              </div>
            );
          })}
          {/* <div className='d-flex justify-content-end'> */}
          {/* <button type="submit" className=" btn btn-primary ">
            {mode === 'edit' ? 'Update' : 'Submit'}
          </button></div> */}
        </form>
      </div>
    </div>
    </div>
  );
};

DynamicOffcanvas.propTypes = {
  // visible: PropTypes.bool.isRequired,
  // onClose: PropTypes.func.isRequired,
  title:PropTypes.string.isRequired,
  schema: PropTypes.array.isRequired,
  section: PropTypes.string.isRequired,
  formData: PropTypes.object,
  onSubmit: PropTypes.func,
  mode: PropTypes.oneOf(['add', 'edit']),
};

export default DynamicOffcanvas;
